export const ASSIGNMENT_LINE_KEY_DEFAULT = "default";
export const ASSIGNMENT_LINE_KEY_REHEARSAL = "rehearsal";

/** Sort default/other first, rehearsal last. */
export function compareAssignmentLineKeys(a: string, b: string): number {
  const rank = (key: string) => {
    if (key === ASSIGNMENT_LINE_KEY_REHEARSAL) return 10_000;
    if (key === ASSIGNMENT_LINE_KEY_DEFAULT) return 5000;
    return 6000;
  };
  const diff = rank(a) - rank(b);
  if (diff !== 0) return diff;
  return a.localeCompare(b);
}

export type TeamAssignmentFilter = "all" | "rehearsal" | "show";

export function filterAssignmentsByTeamView<
  T extends {
    rehearsalDays?: number;
  },
>(assignments: T[], view: TeamAssignmentFilter): T[] {
  if (view === "all") return assignments;
  return assignments.filter((a) => {
    if (view === "rehearsal") {
      return typeof a.rehearsalDays === "number" && a.rehearsalDays > 0;
    }
    if (view === "show") {
      return typeof a.rehearsalDays !== "number" || a.rehearsalDays === 0;
    }
    return true;
  });
}
